import { urlForImage } from '@/sanity/lib/image'
import Image from 'next/image'

const Photo = ({ image }) => {
  const base = 'relative w-full aspect-[3/4]'
  
  return (
    <div className={base}>
      <Image
        src={urlForImage(image).url()}
        alt={image.alt}
        fill
        placeholder="blur"
        blurDataURL={image.metadata.lqip}
        className="object-cover"
      />
    </div>
  )
}

export default Photo
